import { useQRCode } from 'next-qrcode'
import { Box } from '@mui/material'

type Props = {
  text: string
}

export const QRCode = ({ text }: Props) => {
  const { Canvas } = useQRCode()

  return (
    <Box sx={{ border: 1, borderColor: 'grey.500' }}>
      <Canvas
        text={text}
        options={{
          type: 'image/jpeg',
          quality: 0.3,
          level: 'H',
          margin: 2,
          width: 175,
        }}
      />
    </Box>
  )
}
